import { ShopifyLinklistService } from './shopify-linklist.service.js'

import type { FAQItem, ShopifyCollectionMetafields } from '../types/index.js'

export class ShopifyCollectionService {
  /**
   * Get the parent collection of a sub collection by handle
   * @param handle The sub collection handle
   */
  public static getParent(handle: string) {
    const parentLink = ShopifyLinklistService.getParentLinkByHandle(
      handle,
      'collection_link',
    )
    return parentLink?.object?.handle || undefined
  }

  /**
   * Get the main and sub collection of a sub collection by handle.
   * @param handle The main or sub collection handle
   */
  public static getSubCollection(handle: string) {
    const parentHandle = this.getParent(handle)

    if (parentHandle) {
      return {
        mainCollection: parentHandle,
        subCollection: handle,
      }
    } else {
      return {
        mainCollection: handle,
      }
    }
  }

  public static parseFaqFromMetafields(
    metafields?: ShopifyCollectionMetafields,
  ) {
    const questions = metafields?.c_f['collection-faq-question']
    const answers = metafields?.c_f['collection-faq-answer']
    const faqs: FAQItem[] = []

    if (!questions || !answers) {
      return faqs
    }

    for (let i = 0; i < questions.length; i++) {
      const question = questions[i]
      const answer = answers[i]
      if (question && answer) {
        faqs.push({
          question,
          answer,
        })
      }
    }

    return faqs
  }
}
